import { useCallback, useState } from 'react';

// ลาก mouse (คลิกค้าง + ลาก) เพื่อ scroll แนวนอน/แนวตั้งของตาราง — เดิมต้อง scroll ผ่าน scrollbar/
// trackpad เท่านั้น ตอนนี้ตารางกว้างเกิน container (2 คอลัมน์ "อนุมัติโดย/เวลา" กับ "หมายเหตุการอนุมัติ"
// ต้อง scroll ถึงจะเห็น ดู COL_WIDTHS ใน constants/tabs.js) เลยอยากให้ลากด้วย mouse ได้เลย — pattern
// เดียวกับ onContainerMouseDown ใน components/Table/ProjectDashboardTable.js (ไม่มี pageScale เพราะ
// หน้านี้ไม่มีฟีเจอร์ zoom)
export function useDragScroll(containerRef) {
  const [isDragging, setIsDragging] = useState(false);

  const onMouseDown = useCallback(
    (e) => {
      if (e.button !== 0) return;
      // ไม่ดักลาก ถ้าเริ่มคลิกที่ปุ่ม/checkbox/input ฯลฯ — กันชนกับ action ปกติของตาราง (เลือกแถว,
      // อนุมัติ/ปฏิเสธ/รอก่อน, เปิด modal)
      if (e.target.closest('button, input, a, [role="button"], [class*="MuiIconButton"]')) return;
      const el = containerRef.current;
      if (!el) return;
      const startX = e.clientX;
      const startY = e.clientY;
      const startLeft = el.scrollLeft;
      const startTop = el.scrollTop;
      let moved = false;
      const onMove = (me) => {
        const dx = me.clientX - startX;
        const dy = me.clientY - startY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
        if (moved) {
          el.scrollLeft = startLeft - dx;
          el.scrollTop = startTop - dy;
          me.preventDefault();
        }
      };
      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        setIsDragging(false);
      };
      setIsDragging(true);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },
    [containerRef],
  );

  return { isDragging, onMouseDown };
}
